import poser from '../assets/images/poser.jpg';
import PageHeader from '../components/PageHeader';
import VideoEmbed from '../components/VideoEmbed';
import { videos, BANDCAMP_ALBUM_URL } from '../data/videos';

const Listen = () => {
    return (
        <>
            <PageHeader title='Listen' kicker='Music & video' image={poser} imagePosition='center 30%' />
            <section className='band'>
                <div className='container listen'>
                    <aside className='listen__player'>
                        <p className='eyebrow'>Debut album</p>
                        <h2 className='heading'>Orphans</h2>
                        <iframe
                            className='bandcamp'
                            title="O, Kenayda - Debut album 'Orphans' on Bandcamp"
                            src='https://bandcamp.com/EmbeddedPlayer/album=1146456162/size=large/bgcol=333333/linkcol=ffffff/tracklist=true/transparent=true/'
                            seamless
                        >
                            <a href={BANDCAMP_ALBUM_URL}>Orphans by O, Kenayda</a>
                        </iframe>
                    </aside>
                    <div className='listen__videos'>
                        <p className='eyebrow'>Watch</p>
                        <h2 className='heading'>Videos</h2>
                        <div className='video-grid'>
                            {videos.map((video, index) => (
                                <article className={`video-card ${index === 0 ? 'video-card--wide' : ''}`} key={video.id}>
                                    <VideoEmbed video={video} />
                                    <h3 className='video-card__title'>{video.title}</h3>
                                    <p className='video-card__kind'>{video.kind}</p>
                                </article>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Listen
